<div [formGroup]="formGroup()">
  <div class="resource-link position-relative">
    <mdb-form-control>
      <input
        mdbInput
        [mdbAutocomplete]="autocomplete"
        [formControl]="searchControl"
        placeholder="{{placeholder() ? (placeholder()!|translate) : null}}"
        (input)="onInputChange($event)"
        [type]="'text'"
        [id]="id() + '-displayed'"
        class="form-control"
        />
      <input type="hidden" [formControlName]="controlName()" [id]="id()">
      @if(!hideLabel()) {
        <label mdbLabel class="form-label" [for]="id() + '-displayed'">{{ label() | translate }}{{ isRequired() ? ' *' : ''}}</label>
      }
      @if(searchService().loading().loading) {
        <div class="autocomplete-loader spinner-border"
          [class.custom-loading]="baseLink() && selectedLink"
        role="status"></div>
      }
    </mdb-form-control>
    @if (isRequired() && control?.hasError('required') && (control?.touched || control?.dirty)) {
      <mdb-error
        >
        {{ label() | translate }} {{'VALIDATION.FROM_THE_LIST' |translate}} {{ 'VALIDATION.IS_REQUIRED' | translate }}.
      </mdb-error>
    }
    @if (control?.hasError('unselected') && (control?.touched || control?.dirty)) {
      <mdb-error>
        {{ 'VALIDATION.SELECT_FROM_LIST' | translate }}
      </mdb-error>
    }

    @if(baseLink() && selectedLink) {
      <a [href]="selectedLink"
        style="margin-top: 3px"
        target="_blank"
        class="link-icon">
        <i class="fas fa-external-link text-primary"></i>
      </a>
    }
  </div>

  <mdb-autocomplete #autocomplete="mdbAutocomplete"
                    (selected)="onSelected($event)"
                    [displayValue]="displayValue">
    @for (option of searchService().models(); track option) {
      <mdb-option [value]="option">
        {{ getOptionLabel(option) }}
      </mdb-option>
    }
    @if (notFound) {
      <div class="autocomplete-no-results">No results found</div>
    }
  </mdb-autocomplete>
</div>
